import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  viewChild,
} from '@angular/core'
import { BaseModule } from 'shared/base/base.module'
import { HtButtonIntent } from 'shared/base/ht-button/ht-button.component'
import {
  HtModalComponent,
  HtModalOptions,
} from 'shared/base/ht-modal/ht-modal.component'
import { ActiveCallWarningService } from 'src/app/services/active-call-warning.service'

@Component({
  selector: 'ht-active-call-warning',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseModule],
  templateUrl: './active-call-warning.component.html',
})
export class ActiveCallWarningComponent {
  readonly #warningService = inject(ActiveCallWarningService)

  readonly isVisible = this.#warningService.isVisible
  readonly modal = viewChild(HtModalComponent)

  readonly modalOptions: HtModalOptions = {
    title: { text: "You're on a call" },
    size: 'small',
    rightBtnArray: [
      {
        show: true,
        text: 'Got it',
        intent: HtButtonIntent.PRIMARY,
        click: () => this.onGotIt(),
      },
    ],
  }

  constructor() {
    effect(() => {
      const modal = this.modal()
      if (!modal) {
        return
      }
      if (this.isVisible()) {
        modal.open()
      } else {
        modal.close(false)
      }
    })
  }

  onGotIt() {
    this.#warningService.hide()
  }
}
